import { extendTheme } from "@mui/joy/styles";
import { colors, radius, shadow } from "./tokens";
import "./types";

export const joyTheme = extendTheme({
	colorSchemes: {
		light: {
			palette: {
				primary: colors.primary,
				success: colors.success,
				warning: colors.warning,
				danger: colors.danger,
				neutral: colors.neutral,
				background: {
					body: colors.background.body,
					surface: colors.background.surface,
					level1: colors.background.level1,
					level2: colors.background.level2,
					nav: colors.background.nav,
				},
				text: {
					primary: colors.text.primary,
					secondary: colors.text.secondary,
					tertiary: colors.text.tertiary,
					nav: colors.text.nav,
					navMuted: colors.text.navMuted,
				},
				divider: colors.border.default,
			},
		},
	},
	radius: {
		xs: radius.xs,
		sm: radius.sm,
		md: radius.md,
		lg: radius.lg,
		xl: radius.xl,
	},
	shadow: {
		xs: shadow.xs,
		sm: shadow.sm,
		md: shadow.md,
		lg: shadow.lg,
		xl: shadow.xl,
	},
	fontFamily: {
		body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
		display: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
	},
	components: {
		JoySheet: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					borderRadius: 0,
					...(ownerState.variant === "outlined" && {
						borderColor: colors.border.default,
						boxShadow: shadow.sm,
						backgroundColor: colors.background.surface,
					}),
				}),
			},
		},
		JoyButton: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					borderRadius: 0,
					...(ownerState.color === "primary" && ownerState.variant === "solid" && {
						backgroundColor: colors.button.primary.background,
						color: colors.button.primary.text,
						"&:hover": { backgroundColor: colors.button.primary.hover },
						"&:active": { backgroundColor: colors.button.primary.hover },
					}),
					...(ownerState.color === "success" && ownerState.variant === "solid" && {
						backgroundColor: colors.button.success.background,
						color: colors.button.success.text,
						"&:hover": { backgroundColor: colors.button.success.hover },
						"&:active": { backgroundColor: colors.button.success.hover },
					}),
					...(ownerState.color === "neutral" && ownerState.variant === "outlined" && {
						backgroundColor: colors.button.secondary.background,
						borderColor: colors.button.secondary.border,
						color: colors.button.secondary.text,
						"&:hover": { backgroundColor: colors.background.level1 },
					}),
				}),
			},
		},
		JoyTab: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					...(ownerState.color === "primary" && ownerState.selected && {
						color: colors.primary[500],
						fontWeight: 600,
					}),
				}),
			},
		},
		JoyTabList: {
			styleOverrides: {
				root: {
					borderBottom: `1px solid ${colors.table.divider}`,
					boxShadow: "none",
				},
			},
		},
		JoyTable: {
			styleOverrides: {
				root: {
					borderRadius: 0,
					border: `1px solid ${colors.table.divider}`,
					backgroundColor: colors.background.surface,
					"--TableCell-headBackground": colors.table.header,
					"--TableRow-hoverBackground": colors.table.rowHover,
					"--TableCell-borderColor": colors.table.divider,
				},
			},
		},
		JoyChip: {
			styleOverrides: {
				root: ({ ownerState }) => ({
					borderRadius: 0,
					...(ownerState.color === "primary" && ownerState.variant === "soft" && {
						backgroundColor: colors.buildingList.badgeBackground,
						color: colors.buildingList.badgeText,
					}),
					...(ownerState.color === "success" && ownerState.variant === "soft" && {
						backgroundColor: colors.success[100],
						color: colors.success[700],
						borderColor: colors.success[200],
					}),
				}),
			},
		},
		JoyInput: {
			styleOverrides: {
				root: () => ({
					borderRadius: 0,
					"--Input-focusedThickness": "2px",
				}),
			},
		},
		JoySelect: {
			styleOverrides: {
				root: () => ({
					borderRadius: 0,
				}),
			},
		},
		JoyCard: {
			styleOverrides: {
				root: () => ({
					borderRadius: 0,
					boxShadow: shadow.sm,
					border: `1px solid ${colors.border.default}`,
					backgroundColor: colors.background.surface,
				}),
			},
		},
		JoyModalDialog: {
			styleOverrides: {
				root: () => ({
					borderRadius: 0,
					boxShadow: shadow.lg,
					border: `1px solid ${colors.border.default}`,
					backgroundColor: colors.background.surface,
				}),
			},
		},
	},
});